export default "__VITE_PUBLIC_ASSET__6bb90255__"